import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
}

const PaneTitleBase = (props: IProps) =>
  <div className={props.className}>
    {props.children}
  </div>

const PaneTitleStyled = styled(PaneTitleBase)`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 26px;
  font-weight: 500;
  white-space: nowrap;
  user-select: none;
`

const PaneTitle = (props: IProps) => <PaneTitleStyled {...props}/>

export { PaneTitle }
